<template>
    <div class>
        <div class="c-card u-p-medium u-text-small u-mb-small">
            <div class="row align-items-center mb-4">
                <div class="col-sm-4">
                    <h1 v-if="!contact" class="vx-heading vx-heading--style-primary vx-heading--level-1" data-test="contact-form-title">Create Contact</h1>
                    <h1 v-else class="vx-heading vx-heading--style-primary vx-heading--level-1" data-test="contact-form-title">Edit Contact</h1>
                </div>
                <div class="col-sm-4 d-flex align-items-center">
                        <div class="c-avatar c-avatar--xlarge u-inline-block">
                            <contact-avatar :size="1" color="var(--color-primary-dark)" :contact="contactData" class=""></contact-avatar>
                        </div>

                        <p
                            class="u-block u-color-primary vx-text vx-text--level-2 vx-text--style-primary ml-3"
                            data-test="contact-form-contact-name"
                        >{{ contactData.first_name || 'New'}} {{ contactData.last_name || 'Contact'}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-4 u-mb-small">
                            <div class="c-field">
                                <vx-form-group label="First name">
                                    <vx-input
                                        type="text" maxlength="80"
                                        v-model="contactData.first_name"/>
                                </vx-form-group>
                            </div>
                        </div>

                        <div class="col-sm-4 u-mb-small">
                            <div class="c-field">
                                <vx-form-group label="Last name">
                                    <vx-input
                                        type="text" maxlength="80"
                                        v-model="contactData.last_name"/>
                                </vx-form-group>
                            </div>
                        </div>

                        <div class="col-sm-4 u-mb-small">
                            <div class="c-field">
                                <vx-form-group label="Phone" :errors="v$.contactData.phone.$errors">
                                    <vx-input
                                        @input="v$.$touch()"
                                        type="text" maxlength="80"
                                        v-model="contactData.phone"
                                        :disabled="contact?.id ? true : false"
                                    />
                                        <small
                                            v-if="!contact?.id && warnings.phone && ! v$.contactData.phone.$error"
                                            class="c-field__message u-color-warning"
                                        >
                                            <i class="fa fa-exclamation-circle"></i>
                                            Double check, is this a valid phone number?
                                        </small>
                                </vx-form-group>
                            </div>
                        </div>
                    </div>
                    <!-- eo .row -->

                    <div class="row">
                        <div class="col-sm-4 u-mb-small">
                            <div class="c-field">
                                <vx-form-group label="Email" :errors="v$.contactData.email.$errors">
                                    <vx-input
                                        @input="v$.$touch()"
                                        type="email"
                                        v-model="contactData.email"/>
                                </vx-form-group>
                            </div>
                        </div>
                        <div class="col-sm-offset-8 col-sm-6 u-mb-small">
                            <div class="c-field">
                                <vx-form-group label="Time zone">
                                    <vx-select
                                        class="timezone-input"
                                        :model-value="selectedTimeZone"
                                        :options="timezonesOptions"
                                        @search="onSearchTimeZone"
                                        @update:model-value="selectTimeZone"
                                        :clearable="false"
                                        placeholder="Time zone"
                                    >
                                        <template #no-options="{ search }">
                                            <div class="timezone-input__no-options">
                                                <template v-if="!newOnEmpty && search">
                                                    Sorry, no matching options.
                                                </template>
                                                <template v-else>
                                                    Start typing to search timezone
                                                </template>
                                            </div>
                                        </template>
                                        <template #option="{ option }">
                                            <div class="timezone-input__option-text" v-if="option.name">{{ option.name }}</div>
                                        </template>
                                        <template #selected-option="{ option }">
                                            <div class="timezone-input__option-text">{{ option.label }}</div>
                                        </template>
                                    </vx-select>
                                </vx-form-group>
                            </div>
                        </div>
                    </div>
                    <!-- eo .row -->

                    <!-- eo .row -->
                </div>
                <!-- eo .col -->
            </div>
            <!-- eo .row -->

            <div class="row">
                <div class="col-sm-12 col-sm-offset-2">
                    <div class="row">
                        <div class="col-sm-12">
                            <hr class="u-mt-medium u-mb-medium">
                            <h4 class="u-mt-medium u-mb-medium">
                                <span>Tags</span>
                            </h4>
                        </div>
                        <tag-selector-v2
                            :selected-tags="selectedTags"
                            @add="addTag"
                            @remove="removeTag"
                        >
                        </tag-selector-v2>
                        <div class="col-sm-12">
                            <hr class="u-mt-medium u-mb-medium">
                        </div>
                    </div>
                    <!-- eo .row -->
                </div>
                <!-- eo .col -->
            </div>
            <!-- eo .row -->

            <div v-if="FEATURES.contact_groups" class="row">
                <div class="col-sm-12 col-sm-offset-2">
                    <div class="row">
                        <div class="col-sm-12">
                            <h4 class="u-mt-medium u-mb-medium">
                                <span>Groups</span>
                            </h4>
                        </div>
                        <div class="col-sm-12">
                            <contact-form-groups :selected-groups="selectedGroups" @add="addGroup"
                                @remove="removeGroup"></contact-form-groups>
                        </div>
                        <div class="col-sm-12">
                            <hr class="u-mt-medium u-mb-medium">
                        </div>
                    </div>
                    <!-- eo .row -->
                </div>
                <!-- eo .col -->
            </div>

            <div class="row align-items-center justify-content-start u-mb-small">
                <div class="col-sm-2 col-sm-offset-2">
                    <vx-heading :level="3" data-test="custom-attrs-header">Custom Attributes</vx-heading>
                </div>
                <div class="col-sm-1 col-sm-offset-2">
                    <vx-fab-button size="extra-small" appearance="primary" @click="addCustomAttr" data-test="fab-plus-btn">
                        <vx-icon name="plus" alt="Add custom attribute"></vx-icon>
                    </vx-fab-button>
                </div>
            </div>
            <!-- eo .row -->

            <small v-if="!customAttributesAreValid" class="c-field__message u-color-danger">
                <i class="fa fa-times-circle"></i>
                Please check custom attributes.
            </small>

            <contact-custom-attribute-row
                v-for="(attr, index) in customAttributes"
                :key="attr.id"
                @invalid="customAttributes[index].invalid = $event"
                v-model:name="attr.key"
                v-model:value="attr.value"
                @remove="removeCustomAttribute(index)"
            ></contact-custom-attribute-row>

            <hr class="u-mt-medium u-mb-medium">
            <contact-subscription-status-v2 @updated="setSubscriptionStatusV2" :contact-id="contact && contact.id" />

            <div class="row">
                <div class="col-sm-12">
                    <hr class="u-mt-medium u-mb-medium">
                </div>

                <div class="col-sm-12">
                    <vx-button
                        data-test="contact-form-create-update-button"
                        class="pull-right u-ml-small"
                        appearance="primary-dark"
                        size="large"
                        :icon-size="12"
                        :has-shadow="true"
                        @click="() => !contact ? createContact() : updateContact()"
                        >{{!contact ? 'Create Contact' : 'Update Contact'}}
                        <i
                            v-if="formIsSubmitting"
                            class="fa fa-spin fa-circle-o-notch"
                        ></i>
                    </vx-button>

                    <vx-button
                        data-test="contact-form-cancel-button"
                        class="pull-right u-ml-small"
                        appearance="transparent-dark-outline"
                        size="large"
                        :icon-size="12"
                        :has-shadow="true"
                        @click="cancelForm"
                        >Cancel
                    </vx-button>
                </div>
            </div>
        </div>
        <!-- eo .card -->
    </div>
</template>


<script>
import TagSelectorV2 from '~/components/general/TagSelectorV2.vue';
import useVuelidate from '@vuelidate/core'
import {required, email} from '@vuelidate/validators'
import {HTTP_INTERNAL_SERVER_ERROR, HTTP_UNPROCESSABLE_ENTITY} from '../../../support/HttpStatuses';
import ContactCustomAttributeRow from './ContactCustomAttributeRow.vue';
import ContactSubscriptionStatusV2 from './ContactSubscriptionStatusV2.vue';
import ContactAvatar from '../shared/ContactAvatar.vue';
import ContactFormGroups from '../form/ContactFormGroups.vue';

import { VxButton, VxFabButton, VxFormGroup, VxHeading, VxIcon, VxInput, VxSelect } from '@voxie/frontend-components-v3';
import { mapState, mapActions } from 'vuex';
import { contactsClient, actionsClient } from '../../../services';
import timeZones from '~/utils/timeZones';
import libphonenumber from 'google-libphonenumber';

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
const PNF = libphonenumber.PhoneNumberFormat;

export default {
    props: ["contact"],
    components: {
        TagSelectorV2,
        ContactCustomAttributeRow,
        ContactSubscriptionStatusV2,
        ContactAvatar,
        VxButton,
        VxFabButton,
        VxFormGroup,
        VxHeading,
        VxIcon,
        VxInput,
        VxSelect,
        ContactFormGroups
    },
    setup() {
        return { v$: useVuelidate() }
    },
    computed: {
        ...mapState({
            selectedContact: (state) => state.contacts_v3.selectedContact,
        }),
        timezonesOptions() {
            return this.timezones.filter((tz) => tz.toLowerCase().indexOf(this.timezoneSearchQuery.toLowerCase()) !== -1);
        },
    },
    inject: ['FEATURES'],
    data() {
        return {
            team_id: Spark.state.currentTeam.id,
            contactData: {
                first_name: null,
                last_name: null,
                phone: null,
                email: null,
                time_zone: null
            },
            warnings: {
                phone: false
            },
            customAttributesAreValid: true,
            selectedTags: [],
            tagOptions: [],
            tagOptionsAreLoading: false,
            customAttributes: [],
            formIsSubmitting: false,
            freshContact: null,
            completedEvents: [],
            completionEvents: [
                "createUpdateContact",
                "syncContactCustomAttributes",
                "syncContactTags",
            ],

            timezones: timeZones,
            timezoneSearchQuery: '',
            selectedTimeZone: null,
            subscriptions: {
                transactional: null,
                marketing: null,
            },
            selectedGroups: [],
        };
    },

    validations() {
        return {
            contactData: {
                phone: {
                    required
                },
                email: {
                    email,
                },
            }
        }
    },

    created() {
        Bus.$emit("ContactFormCreated");

        if (this.contact) {
            this.contactData.first_name = this.contact.first_name;
            this.contactData.last_name = this.contact.last_name;
            this.contactData.phone = this.contact.phone;
            this.contactData.email = this.contact.email ? this.contact.email.trim() : '';
            this.contactData.time_zone = this.contact.time_zone;
            this.selectedTimeZone = this.contact.time_zone;
            this.validatePhone(this.contactData.phone);
        }
    },

    mounted() {
        if (this.FEATURES.contact_groups) {
            this.completionEvents.push('syncContactGroups');
        }

        if (!this.contact?.id) return;

        const contactId = this.contact.id;
        const $toasted = this.$toasted;

        this.loadTagsList({ contactId, $toasted })
            .then(({data}) => {
                this.selectedTags = data.data.map(({id, tag_name}) => ({id, tag_name: tag_name.toLowerCase()}));
            });
        this.loadCustomAttributesList({ contactId, $toasted })
            .then(({data}) => {
                this.customAttributes = data.data;
            });

        if (this.FEATURES.contact_groups) {
            contactsClient.listContactGroups(this.team_id, contactId)
            .then(({data}) => {
                this.selectedGroups = data.data.map((group) => ({
                    group_id: group.group_id.toLowerCase()
                }));
            }).catch((error) => {
                console.error(error)
                this.$toasted.global.platform_error();
            });
        }
    },

    methods: {
        ...mapActions({
            'loadTagsList': 'contacts_v3/loadTagsList',
            'loadCustomAttributesList': 'contacts_v3/loadCustomAttributesList',
        }),

        onSearchTimeZone(query) {
            this.timezoneSearchQuery = query.trim();
        },

        selectTimeZone(op) {
            this.selectedTimeZone = op;
            if (op != null) {
                this.contactData.time_zone = op;
            }
        },
        createContact() {
            if (!this.validate()) {
                this.$toasted.error("Please check form data.");
                return;
            }

            if (!this.runPreSubmitActions()) {
                return;
            }

            if (this.formIsSubmitting) {
                return;
            }

            this.formIsSubmitting = true;

            this.completedEvents = [];

            let data = this.contactData;

            contactsClient.contactSave(this.team_id, data)
                .then(async response => {
                    let contact_id = response.data.id;
                    this.completedEvents.push("createUpdateContact");

                    await this.updateContactSubscription(contact_id)

                    this.syncContactTags(contact_id);
                    this.syncContactCustomAttributes(contact_id);

                    if (this.FEATURES.contact_groups) {
                        this.syncContactGroups(contact_id);
                    }
                    actionsClient.send('contact_added');
                })
                .catch(error => {
                    console.error(error);
                    if (error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
                        this.$toasted.global.platform_error();
                    } else {
                        const responseErrors = error?.response?.data?.errors || {
                            error: [error?.response?.data?.message || 'Something wrong'],
                        };

                        let errors = [];

                        Object.keys(responseErrors).forEach((key) => {
                            const keyErrors = responseErrors[key].map((x) => `<p>${x}</p>`).join('\n');
                            errors.push(keyErrors);
                        });

                        let errorMessage =
                            '<p class="u-text-danger">We found the following errors:</p><br />' +
                            errors.join("\n<br />");

                        Swal.fire({
                            title: "Oops..",
                            html: errorMessage,
                            icon: "error",
                        });
                    }
                }).finally(() => {
                    this.formIsSubmitting = false;
                });
        },

        updateContact() {
            if (!this.validate()) {
                this.$toasted.error("Please check form data.");
                return;
            }

            if (!this.runPreSubmitActions()) {
                return;
            }

            if (this.formIsSubmitting) {
                return;
            }

            this.formIsSubmitting = true;

            this.completedEvents = [];

            const data = {...this.contactData};

            delete data.phone;

            contactsClient.contactUpdate(this.team_id, this.contact.id, data)
                .then(async response => {
                    let contact_id = response.data.id;
                    this.completedEvents.push("createUpdateContact");

                    await this.updateContactSubscription(contact_id)

                    this.syncContactTags(contact_id);
                    this.syncContactCustomAttributes(contact_id);
                    if (this.FEATURES.contact_groups) {
                        this.syncContactGroups(contact_id);
                    }
                })
                .catch(error => {
                    console.error(error);
                    if (error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
                        this.$toasted.global.platform_error();
                    } else {
                        const responseErrors = error?.response?.data?.errors || {
                            error: [error?.response?.data?.message || 'Something wrong'],
                        };

                        let errors = [];

                        Object.keys(responseErrors).forEach((key) => {
                            const keyErrors = responseErrors[key].map((x) => `<p>${x}</p>`).join('\n');
                            errors.push(keyErrors);
                        });

                        let errorMessage =
                            '<p class="u-text-danger">We found the following errors:</p><br />' +
                            errors.join("\n<br />");

                        Swal.fire({
                            title: "Oops..",
                            html: errorMessage,
                            icon: "error",
                        });
                    }
                }).finally(() => {
                    this.formIsSubmitting = false;
                });
        },

        cancelForm() {
            Bus.$emit("ContactFormClose");
        },

        runPreSubmitActions() {
            try {
                this.contactData.phone = phoneUtil.format(
                    phoneUtil.parse(this.contactData.phone, "US"),
                    PNF.E164
                );

                return true;
            } catch (err) {
                Swal.fire({
                    title: "Oops..",
                    html: err.message,
                    icon: "error",
                });

                return false;
            }
        },

        createUpdateContactComplete() {
            for (var evt of this.completionEvents) {
                if (this.completedEvents.indexOf(evt) == -1) {
                    return;
                }
            }

            let msg = "";
            let doneEvent = "";

            if (this.contact) {
                msg = "Contact was successfully updated.";
                doneEvent = "contactUpdated";
            } else {
                msg = "Contact was successfully created.";
                doneEvent = "contactCreated";
            }

            Swal.fire({
                title: 'Success!',
                text: msg,
                icon: 'success',
            });

            Bus.$emit(doneEvent, this.freshContact);

            Bus.$emit("ContactFormClose");
        },

        syncContactCustomAttributes(contact_id) {
            contactsClient.contactsSyncCustomAttributes(this.team_id, contact_id, { custom_attributes: this.customAttributes })
                .then(response => {
                    this.freshContact = response.data;
                    this.completedEvents.push("syncContactCustomAttributes");
                    this.createUpdateContactComplete();
                })
                .catch(error => {
                    const status = error.response.status;
                    if (status === HTTP_UNPROCESSABLE_ENTITY) {
                        const responseErrors = error.response.data.errors;
                        let errors = [];

                        Object.keys(responseErrors).forEach((key) => {
                            const keyErrors = responseErrors[key].map((x) => `<p>${x}</p>`).join('\n');
                            errors.push(keyErrors);
                        });

                        let errorMessage =
                            '<p class="u-text-danger">We found the following errors:</p><br />' +
                            errors.join("\n<br />");

                        Swal.fire({
                            title: "Oops..",
                            html: errorMessage,
                            icon: "error",
                        });
                    } else if (status === 400) {
                        Swal.fire({
                            title: "Oops..",
                            text: error.response.data.message,
                            icon: "error",
                        });
                    } else {
                        console.error(error);
                        console.error(error.response.data);
                        this.$toasted.global.platform_error();
                    }
                });
        },

        syncContactTags(contact_id) {
            contactsClient.contactsSyncTags(this.team_id, contact_id, { tag_names: this.selectedTags.map((tag) => tag.tag_name.toLowerCase()) })
                .then(response => {
                    this.freshContact = response.data;
                    this.completedEvents.push("syncContactTags");
                    this.createUpdateContactComplete();
                })
                .catch(error => {
                    console.error(error.response.data);

                    this.formIsSubmitting = false;
                    const keys = Object.keys(error.response.data.errors);

                    let errorMessage = ''
                    keys.forEach((key) => {
                        errorMessage += `${key}: ${error.response.data.errors[key]}\n<br>`;
                    });

                    Swal.fire({
                        title: 'Oops..',
                        html: `<p>${errorMessage}</p>`,
                        icon: 'error',
                    });
                });
        },

        syncContactGroups(contact_id) {
            contactsClient.contactsSyncGroups(this.team_id, contact_id, { group_ids: this.selectedGroups.map((group) => group.group_id.toLowerCase()) })
                .then(() => {
                    this.completedEvents.push("syncContactGroups");
                    this.createUpdateContactComplete();
                })
                .catch(error => {
                    console.error(error.response.data);

                    this.formIsSubmitting = false;
                    const keys = Object.keys(error.response.data.errors);

                    let errorMessage = ''
                    keys.forEach((key) => {
                        errorMessage += `${key}: ${error.response.data.errors[key]}\n<br>`;
                    });

                    Swal.fire({
                        title: 'Oops..',
                        html: `<p>${errorMessage}</p>`,
                        icon: 'error',
                    });
                });
        },

        addCustomAttr() {
            let obj = {};
            obj.id = "new-" + Math.floor(Math.random() * 1000000000);
            obj.new = true;
            obj.invalid = true;
            obj.key = ''
            obj.value = ''

            this.customAttributes.push(obj);
        },

        addTag(newTag) {
            if (newTag === null) return;

            if (this.selectedTags.find((tag) => tag.tag_name === newTag.tag_name)) {
                return;
            }

            this.selectedTags.push(newTag);
        },

        removeTag(tagName) {
            this.selectedTags = this.selectedTags.filter((tag) => tag.tag_name !== tagName);
        },

        addGroup(newGroup) {
            if (newGroup === null) return;

            if (this.selectedGroups.find((group) => group.group_id === newGroup.group_id)) {
                return;
            }

            this.selectedGroups.push(newGroup);
        },

        removeGroup(groupId) {
            this.selectedGroups = this.selectedGroups.filter((group) => group.group_id !== groupId);
        },

        validateCustomAttributes() {
            this.customAttributesAreValid = true;

            for (let attr of this.customAttributes) {
                if (attr.invalid) {
                    this.customAttributesAreValid = false;
                    break;
                }
            }
        },

        validate() {
            this.v$.$validate();

            this.validatePhone(this.contactData.phone);

            this.validateCustomAttributes();

            return this.customAttributesAreValid && !this.v$.$invalid;
        },

        validatePhone(phone) {
            let valid = true;

            try {
                valid = phoneUtil.isValidNumber(
                    phoneUtil.parse(phone, "US")
                );
            } catch (e) {
                valid = false;
            }

            if (!valid) {
                this.warnings.phone = true;
            }
        },

        removeCustomAttribute(index) {
            this.customAttributes.splice(index, 1);
        },

        setSubscriptionStatusV2({ type, status }) {
            if (status === 'unknown') {
                this.subscriptions[type] = null;
            } else {
                this.subscriptions[type] = status;
            }
        },
        async updateContactSubscription(contactId) {
            try {
                if (this.subscriptions.marketing === 'opt_in') {
                    await contactsClient.contactSubscriptionOptIn(this.team_id, contactId, 'marketing');
                } else if (this.subscriptions.marketing === 'opt_out') {
                    await contactsClient.contactSubscriptionOptOut(this.team_id, contactId, 'marketing');
                }

                if (this.subscriptions.transactional === 'opt_in') {
                    await contactsClient.contactSubscriptionOptIn(this.team_id, contactId, 'transactional');
                } else if (this.subscriptions.transactional === 'opt_out') {
                    await contactsClient.contactSubscriptionOptOut(this.team_id, contactId, 'transactional');
                }
            } catch (e) {
                console.error(e)
                this.$toasted.global.platform_error();
            }
        }
    }
};
</script>
